import { render, staticRenderFns } from "./Aggregator.vue?vue&type=template&id=51fe95e4&scoped=true&"
import script from "./Aggregator.vue?vue&type=script&lang=js&"
export * from "./Aggregator.vue?vue&type=script&lang=js&"
import style0 from "./Aggregator.vue?vue&type=style&index=0&id=51fe95e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe95e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
